import api from './axios';

export const getStudents = (params) => api.get('/students', { params });
export const getStudent = (id) => api.get(`/students/${id}`);
export const createStudent = (data) => api.post('/students', data);
export const updateStudent = (id, data) => api.put(`/students/${id}`, data);
export const deleteStudent = (id) => api.delete(`/students/${id}`);
export const getStudentNotes = (id) => api.get(`/students/${id}/notes`);
export const addStudentNote = (id, data) => api.post(`/students/${id}/notes`, data);
export const deleteStudentNote = (studentId, noteId) => api.delete(`/students/${studentId}/notes/${noteId}`);
export const getStudentParents = (id) => api.get(`/students/${id}/parents`);
export const addStudentParent = (id, data) => api.post(`/students/${id}/parents`, data);
// Yakınlık (anne/baba/vasi) ve bildirim tercihini günceller. Veli kullanıcısının
// kendisi değişmez — o bağ sabit, değişmesi gerekiyorsa bağ silinip yenisi eklenir.
export const updateStudentParent = (id, parentId, data) =>
  api.put(`/students/${id}/parents/${parentId}`, data);
export const getStudentCharges = (id) => api.get(`/students/${id}/charges`);
export const getStudentPayments = (id) => api.get(`/students/${id}/payments`);
export const getStudentCertificates = (id) => api.get(`/students/${id}/certificates`);
export const getFollowups = (id) => api.get(`/students/${id}/followups`);
export const addFollowup = (id, data) => api.post(`/students/${id}/followups`, data);
export const getHistoricalCourseStatus = (id) => api.get(`/students/${id}/historical-course-status`);
export const completeCourseHistorical = (id, courseId, topicIds) =>
  api.post(`/students/${id}/complete-course-historical`, { course_id: courseId, ...(topicIds ? { topic_ids: topicIds } : {}) });
export const undoCourseHistorical = (id, courseId, topicIds) =>
  api.post(`/students/${id}/undo-course-historical`, { course_id: courseId, ...(topicIds ? { topic_ids: topicIds } : {}) });
// Öğrenci işlem dökümü (kim, ne zaman, ne yaptı). Şube müdürü ve üstüne açık.
export const getStudentActivity = (id, params) =>
  api.get(`/students/${id}/activity`, { params });

// Veli panosunda sertifika ilerleyisi (X/Y) gorunsun mu. Ayri uc: updateStudent
// ogretmene de acik, bu karar sube muduru ve ustune ait (backend'de kilitli).
export const setCertificateProgressVisibility = (id, show) =>
  api.put(`/students/${id}/certificate-progress-visibility`, { show_certificate_progress: show });
